var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTeams = function SvgTeams(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.806 19.15.713-.194 1.035-.679M16.745 18.277l1.035.679 2.687.732L21 22h-8.129M15.15 19.872V22M12.78 13.19c0-.953.612-1.415 1.51-1.058a8.507 8.507 0 0 0 3.23.78v.924c0 1.66-.651 3.927-2.37 3.927-1.72 0-2.37-2.267-2.37-3.927v-.645Z",
    stroke: "#fff",
    strokeWidth: 0.45,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.365 19.34c-.895-1.731-.895-4.676-.895-6.537a3.094 3.094 0 0 0-3.36-3.036 3.094 3.094 0 0 0-3.36 3.036 18.37 18.37 0 0 1-.7 6.106",
    stroke: "#fff",
    strokeWidth: 0.45,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.554 16.829v1.448l1.595 1.596 1.596-1.596v-1.448",
    stroke: "#fff",
    strokeWidth: 0.45,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68 16.679v1.011l-1.745 1.4-1.745-1.4v-1.011",
    stroke: "#fff",
    strokeWidth: 0.45,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m5.19 17.69-1.019.786-2.646.847L1 22h11.871l-.525-2.677-2.646-.847-1.019-.786M6.935 19.09V22M9.612 14.306a.99.99 0 0 1-.67-.574c-.073-.224.369-.994-.034-1.661-.184-.148-.576-.076-.634-.069-.764.199-1.57.17-2.318-.084a.837.837 0 0 0-1 .526c-.103.596-.114 1.258-.221 1.875-.182-.092-.244-.013-.476-.246",
    stroke: "#fff",
    strokeWidth: 0.45,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 14.047c-.116 1.607-1.036 3.65-2.664 3.65-1.66 0-2.583-2.12-2.67-3.74l-.007-.117c.002-.576-.25-.82-.233-1.397a2.417 2.417 0 0 1 1.586-2.048c.664-.25 1.343-.46 2.033-.628a2.595 2.595 0 0 1 2.018 2.076c.097.664.08 1.34-.05 1.997l-.013.207ZM7.94 3.535a9.011 9.011 0 0 0-5.798 6.88L11 5.302 7.94 3.535ZM18.484 14.378l1.374-.794A8.983 8.983 0 0 0 16.8 5.12l.001 5.018",
    stroke: "#fff",
    strokeWidth: 0.45,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 10.615V8.65l-3.058 1.766A8.98 8.98 0 0 0 4.5 18.222M11 5.3h-.001l5.8 3.349V5.12a9.004 9.004 0 0 0-8.86-1.585L11 5.3V5.3ZM18.651 16.738a8.948 8.948 0 0 0 1.207-3.154l-1.374.794",
    stroke: "#fff",
    strokeWidth: 0.45,
    strokeLinejoin: "round"
  })));
};
export default SvgTeams;